import React, { useCallback, useEffect, useRef, useState } from 'react'

import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Icon, Modal } from 'antd'
import { Tag } from 'primereact/tag'

import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { exportCSV, exportExcel } from '../../util/exportUtils'
import Header from './Header'
import DataTable from '../../components/DataTable/DataTable'
import CreateAlternative from './CreateAlternative/CreateAlternative'
import { getMessage } from '../../util/IntlMessages'

const ListAlternativeWallet = function ({ history }) {
  const [alternativesList, setAlternativesList] = useState([])
  const [selectedAlternativeId, setSelectedAlternativeId] = useState(null)
  const [modalDocumentVisible, setModalDocumentVisible] = useState(false)
  const dt = useRef(null)
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    partnerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    documentNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    approvalStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
    emailAddress: { value: null, matchMode: FilterMatchMode.CONTAINS }
  })
  const [globalFilterValue, setGlobalFilterValue] = useState('')

  useEffect(() => {
    const hasAccess = validRule(RULES.CUSTOMER_CONTACT) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }
    getAlternatives({ active: true })
  }, [])

  useEffect(() => {
    clearFilter()
    getAlternatives({ active: true })
  }, [modalDocumentVisible])

  const getAlternatives = async (params) => {
    const items = await request(api.listCustomerAlternative({ ...params }))

    setAlternativesList(items)
  }

  const clearFilter = () => {
    setGlobalFilterValue('')
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      partnerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      documentNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
      approvalStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
      phoneNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
      emailAddress: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value
    let _filters = { ...filters }

    _filters['global'].value = value

    setFilters(_filters)
    setGlobalFilterValue(value)
  }

  const exportCSVData = () => {
    exportCSV(alternativesList, 'lista_de_alternativos')
  }

  const exportExcelData = () => {
    exportExcel(alternativesList, 'lista_de_alternativos')
  }

  const getStatusSeverity = (status) => {
    switch (status) {
      case 'Aguardando aprovação':
        return 'warning'
      default:
        return 'success'
    }
  }

  const statusBodyTemplate = ({ approvalStatus }) => {
    return <Tag value={approvalStatus} severity={getStatusSeverity(approvalStatus)} />
  }

  const editBodyTemplate = ({ id }) => {
    return (
      <Button
        className="p-button-text"
        onClick={() => {
          setModalDocumentVisible(true)
          setSelectedAlternativeId(id)
        }}
      >
        <Icon type="edit" className="default-actionContent-icon" />
      </Button>
    )
  }

  const columns = [
    { header: 'Nome', field: 'partnerName', filterField: 'partnerName', responsive: true },
    { header: 'Documento', field: 'documentNumber', filterField: 'documentNumber', responsive: true },
    {
      header: 'Status',
      field: 'approvalStatus',
      filterField: 'approvalStatus',
      responsive: true,
      body: statusBodyTemplate
    },
    { header: 'Telefone', field: 'phoneNumber', filterField: 'phoneNumber', responsive: true },
    { header: 'Email', field: 'emailAddress', filterField: 'emailAddress', responsive: true },
    { header: 'Editar', body: editBodyTemplate, width: '5rem', responsive: true }
  ]

  const handleCancel = () => {
    clearFilter()
    setModalDocumentVisible(false)
  }

  const updateAlternativeList = useCallback((newAlternative) => {
    setAlternativesList((previousList) => [...previousList, newAlternative])
  }, [])

  return (
    <div className="card">
      <Header
        globalFilterValue={globalFilterValue}
        onGlobalFilterChange={onGlobalFilterChange}
        exportCSV={exportCSVData}
        exportExcelData={exportExcelData}
        history={history}
        updateAlternativeList={updateAlternativeList}
      />
      <DataTable
        ref={dt}
        itemsList={alternativesList}
        filters={filters}
        columns={columns}
        emptyMessage="actionsEmpty"
      />
      <Modal
        destroyOnClose={() => handleCancel()}
        onCancel={() => handleCancel()}
        title={getMessage('createAlternate')}
        footer={null}
        width="70%"
        visible={modalDocumentVisible}
      >
        <CreateAlternative alternativeId={selectedAlternativeId} onCancel={() => handleCancel()} />
      </Modal>
    </div>
  )
}
export default ListAlternativeWallet
